import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  firstNameLabel: {
    id: 'paSL6e',
    defaultMessage: 'First Name',
    description: 'Label for first name field',
  },
  lastNameLabel: {
    id: 'NlrmyX',
    defaultMessage: 'Last Name',
    description: 'Label for last name field',
  },
  companyNameLabel: {
    id: '+JEVl7',
    defaultMessage: 'Company',
    description: 'Label for company name field',
  },
  companyNameLabelOptional: {
    id: '3MOUFd',
    defaultMessage: 'Company (Optional)',
    description: 'Label for optional company name field',
  },
  emailLabel: {
    id: 'bGKAyO',
    defaultMessage: 'Email',
    description: 'Label for email field',
  },
  phoneNumberLabel: {
    id: 'OnH/Yk',
    defaultMessage: 'Phone number',
    description: 'Label for phone number field',
  },
});
